import {Injectable} from '@angular/core';
import {ApiRoutes} from '../../config/api-routes';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs';
import {LoggerService} from '../shared/service/logger.service';

@Injectable()
export class SignoutService {

  constructor(private httpClient: HttpClient, private routes: ApiRoutes, private loggerService: LoggerService) {}

  public signout(): Observable<any> {
    return this.httpClient.get(this.routes.LOGOUT).pipe(
      catchError(error => {
        this.loggerService.error(`Could not sign out cause of ${error.message}`);
        return throwError(true);
      })
    );
  }
}


